import Link from "next/link"
import React from "react"

import Rating from "../Rating/rating"
import UserInfo from "../UserInfo"
import { cn } from '@/utils/index'

export interface User {
  id: string
  name: string
  roles: string
  imageUrl: string
  rate: number
  rating: number
  location?: any
  memberSince?: string
  ratedDate?: string
}

const FeaturedUserCard = ({ profile }: { profile: any }) => {
  const name = `${profile.user.firstName} ${profile.user.lastName}`
  const href = `/consultant/${profile.id}`
  const linkAria = `Visit consultant: ${name}`
  return (
    <Link
      className={cn(
        "group flex h-full w-full flex-col justify-items-start overflow-hidden rounded-2xl bg-slate-100 transition-all hover:shadow-lg dark:bg-black dark:hover:shadow-lg"
      )}
      aria-label={linkAria}
      href={href}
    >
      <div className="p-10 shadow-md">
        <UserInfo name={name} roles={profile.profession.name} imageUrl={profile.user.avatar} orientation="horizontal" />
        <div className="mt-2 flex justify-between">
          <div className="flex space-x-2">
            <Rating stars={profile.averageRating} />
            <p className="pt-1 font-semibold text-black dark:text-white">{profile.averageRating}</p>
          </div>
          <span className={`rounded-full bg-orange-500 px-4 py-1 text-white`}>{profile.user.location?.city || profile.user.location?.state || profile.user.location?.country || "Location not specified"}</span>
        </div>
      </div>
    </Link>
  )
}

export default FeaturedUserCard
